import { Navigate, useSearchParams } from 'react-router-dom'

import { Cookbook } from '../components/Cookbook'
import { DEFAULT_APP_PATH, useMe } from '../lib/auth-client'

/**
 * `/` for guests is the public cookbook.
 * Logged-in users with a household always land on planning;
 * cookbook deep links (`recipeId` / `list`) move to `/recipes`.
 */
export default function RootLanding() {
  const { data: me, isLoading } = useMe()
  const [params] = useSearchParams()
  const signedIn = me?.user?.tenantId != null
  const hasCookbookQuery =
    params.has('recipeId') || params.has('list') || params.has('edit')

  if (isLoading && !me) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Laden…
      </div>
    )
  }

  if (signedIn && hasCookbookQuery) {
    const qs = params.toString()
    return <Navigate to={qs ? `/recipes?${qs}` : '/recipes'} replace />
  }

  if (signedIn) {
    return <Navigate to={DEFAULT_APP_PATH} replace />
  }

  return <Cookbook publicMode />
}
